module.exports = __webpack_public_path__ + "static/img/2.4a9088f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tiankeng/2.jpg
// module id = Wgk6
// module chunks = 1